/**
 * 模块名称：
 * @author ：XXXXX
 */
import { Toast } from 'vant'
import {
  login,
  getSms,
  queryAuth,
  getListByCode,
  setCollection,
  getShareList,
  getRecommendList,
  getAgreementUrl,
  getJobDetail,
  getSignature,
  getCollectionList,
  getHistoryJob,
  getUserInfo,
  getAutoLogout,
  getLogout,
  getloginOrReg,
  getWorkbench,
  getCreatePositionContract,
  isYIMAIJob,
  getUpload,
  getAuthentication,
  getAuthenticationStatus,
  getPrivacyNumber,
  getJobShareParameter,
  getAddUsreToQiyuesuo,
  getPositionContractOofficial,
  getCompanyDetail,
  addJobViewRecord,
  setBehavioralData,
  postsetCollection,
  delPostsetCollection,
  getJobCommissionRule,
  getUserInfoByJobIds,
  getObsUrl,
  jobPackageStatistics,
} from '@/api'
import Cookies from 'js-cookie'
import wxapi from '@/utils/wxapi.js'
import utils from '@/utils/utils'
import { isWeiXin } from '@/utils/openIdLogin'
function filterParams(data) {
  // 过滤参数
  if (!data) {
    return {}
  }
  let cloneData = {}
  Object.keys(data).forEach((key) => {
    if (typeof data[key] != 'function') {
      cloneData[key] = data[key]
    }
  })
  return cloneData
}
const state = {
  loginInfo: '',
  authInfo: null,
  smsTypeTime: '',
  nowJobList: null,
  nowJobListCount: 0,
  historyJobList: null,
  historyJobListCount: 0,
  detailInfo: null,
  agreementInfo: null,
  agreementInfoYsxy: null,
  showLogin: false,
  collectionList: [],
  isFirst: false,
  collectCount: 0,
  historyList: [],
  historyCount: 0,
  userInfo: {},
  openid: '',
  errorCode: 0,
  candidateOrderCount: 0,

  contract_url: '',
  showRecDialog: false,
  license: '',
  privacyData: {},
  shareParameter: {},
  share_content: '',
  showRecom: false,
  botDistance: 0,
  companyDetail: null,
  jobCommissionRule: [],
  senderInfo: {},
  noStartOrEnd: '',
}

const mutations = {
  /**
   * 为state项赋值
   * @param state
   * @param data
   */
  setStateItem(state, data) {
    state[data.key] = data.value
  },
}

const actions = {
  /**
   * 获取手机验证码
   */
  async requestGetSms({ state, commit }, data) {
    try {
      const res = await getSms(data)
      if (res.data.code == 200) {
        Toast('发送成功，请注意查收！')
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  async requestLogin({ state, commit }, data) {
    commit('setStateItem', { key: 'errorCode', value: '' })
    let loginStatus = Cookies.get('loginStatus')
      ? JSON.parse(Cookies.get('loginStatus'))
      : ''
    if (loginStatus && loginStatus.openid && isWeiXin()) {
      data.openid = loginStatus.openid
    } else {
      data.openid = ''
    }
    data.browser = 2
    try {
      let res = null
      if (loginStatus && loginStatus.status == 2) {
        res = await getloginOrReg(data)
      } else {
        res = await login(data)
      }

      if (res.data.code == 200) {
        Cookies.set('loginStatus', '')
        Cookies.set('loginInfo', JSON.stringify(res.data.data))
        commit('setStateItem', { key: 'loginInfo', value: res.data.data })
        data.cb && data.cb()
        Toast('登录成功')
        return false
      } else {
        if (res.data.errorCode) {
          commit('setStateItem', {
            key: 'errorCode',
            value: res.data.errorCode,
          })
          Toast(res.data.message)
        }
        return false
      }
    } catch (e) {
      return false
    }
  },
  async requestAuth({ state, commit }, data) {
    try {
      const res = await queryAuth(data)
      if (res.data.code == 200) {
        Cookies.set('authInfo', JSON.stringify(res.data.data))
        commit('setStateItem', { key: 'authInfo', value: res.data.data })
        data.cb && data.cb()
        data.showDialog && data.showDialog(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  async requestNowJobList({ state, commit }, data) {
    try {
      const res = await getListByCode(data)

      if (res.data.code == 200) {
        // let openList = [];
        // let closeList = [];
        // res.data.data.list.forEach(item => {
        //     item.job_open_status === 20?closeList.push(item): openList.push(item);
        // })

        commit('setStateItem', { key: 'nowJobList', value: res.data.data.list })
        commit('setStateItem', {
          key: 'nowJobListCount',
          value: res.data.data.count,
        })

        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  async requestShareJobList({ state, commit }, data) {
    try {
      const res = await getShareList(data)
      if (res.data.code == 200) {
        // let openList = [];
        // let closeList = [];
        // res.data.data.list.forEach(item => {
        //     item.job_open_status === 20?closeList.push(item): openList.push(item);
        // })
        commit('setStateItem', { key: 'nowJobList', value: res.data.data.list })
        commit('setStateItem', {
          key: 'nowJobListCount',
          value: res.data.data.count,
        })
        commit('setStateItem', {
          key: 'noStartOrEnd',
          value: '',
        })

        let parames = {
          title: res.data.data.share_title,
          dec: res.data.data.share_subtitle,
        }
        wxapi(parames)
        return false
      } else if (res.data.errorCode == 3025 || res.data.errorCode == 3026) {
        commit('setStateItem', {
          key: 'noStartOrEnd',
          value: res.data.errorCode == 3025 ? '活动未开始' : '活动已结束',
        })
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  async requestHistoryJobList({ state, commit }, data) {
    try {
      const res = await getRecommendList(data)

      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'historyJobList',
          value: res.data.data.list,
        })
        commit('setStateItem', {
          key: 'historyJobListCount',
          value: res.data.data.count,
        })
        return false
      } else {
        switch (res.data.errorCode) {
          case 165:
            // token信息错误，跳转到登录页面
            Cookies.remove('loginInfo')
            commit('setStateItem', { key: 'loginInfo', value: '' })
            break
          case 202:
            // 无token信息，跳转到登录页面
            Cookies.remove('loginInfo')
            commit('setStateItem', { key: 'loginInfo', value: '' })
            break
        }
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  async requestJobDetail({ state, commit }, data) {
    try {
      const res = await getJobDetail(data)
      if (res.data.code == 200) {
        let detailInfo = res.data.data
        commit('setStateItem', {
          key: 'detailInfo',
          value: res.data.data,
        })
        data.cb && data.cb()
        let parames = {
          title: detailInfo.position_base.position_name,
          dec:
            detailInfo.position_base.position_salary +
            ' ' +
            detailInfo.position_base.work_city_names.join('、') +
            ' ' +
            detailInfo.position_requirement.education_name +
            ' ' +
            detailInfo.position_requirement.work_years_name,
        }
        wxapi(parames)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  async requestCollectJob({ state, commit }, data) {
    try {
      let res = null

      if (data.data_status == 0) {
        // 增加
        res = await postsetCollection({
          job_id: data.data_id,
        })
      } else {
        // 删除
        res = await delPostsetCollection({
          job_id: data.data_id,
        })
      }
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  async queryAgreementUrl({ state, commit }, data) {
    try {
      const res = await getAgreementUrl(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'agreementInfo', value: res.data.data })
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  //  隐私协议
  async queryAgreementYsxyUrl({ state, commit }, data) {
    try {
      const res = await getAgreementUrl(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'agreementInfoYsxy',
          value: res.data.data,
        })
        return false
      } else {
        Toast({ message: res.data.message, className: 'toast_z' })
        return false
      }
    } catch (e) {
      return false
    }
  },
  async getSignature({ state, commit }, data) {
    try {
      const res = await getSignature(data.data)
      if (res.data.code == 200) {
        data.cb(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  /* 收藏list */
  async requestCollectionList({ commit }, data) {
    try {
      const res = await getCollectionList(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'collectionList',
          value: res.data.data.list || [],
        })
        commit('setStateItem', { key: 'isFirst', value: true })
        commit('setStateItem', {
          key: 'collectCount',
          value: res.data.data.total_rows,
        })
        let parames = {
          title: '上禾蛙hewa.cn，更多职位等你来',
          dec: '猎头上禾蛙—简历不浪费，职位不白费',
        }
        wxapi(parames)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  /* 历史list */
  async requestHistoryJob({ commit }, data) {
    try {
      const res = await getHistoryJob(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'historyList',
          value: res.data.data.list || [],
        })
        commit('setStateItem', { key: 'isFirst', value: true })
        commit('setStateItem', {
          key: 'historyCount',
          value: res.data.data.total_rows,
        })
        let parames = {
          title: '上禾蛙hewa.cn，更多职位等你来',
          dec: '猎头上禾蛙—简历不浪费，职位不白费',
        }
        wxapi(parames)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  /*
      个人信息
      */
  async requireUserInfo({ commit }, data) {
    try {
      let res = await getUserInfo(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'userInfo', value: res.data.data })
        let parames = {
          title: '上禾蛙hewa.cn，更多职位等你来',
          dec: '猎头上禾蛙—简历不浪费，职位不白费',
        }
        wxapi(parames)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  /*
      登退
      */
  async requireAutoLogout({ commit }, data) {
    try {
      let res = await getAutoLogout(data)
      if (res.data.code == 200) {
        if (res.data.data.login_status == 2) {
          data.cb && data.cb()

          Toast('由于您长时间没有进行操作，系统将返回到登录界面！')
        }
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  /*
       退出
       */
  async requireLogout({ commit }, data) {
    try {
      let res = await getLogout(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        Toast(res.data.message)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  //工作台
  async requireWorkbench({ commit }, data) {
    try {
      let res = await getWorkbench(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'candidateOrderCount',
          value: res.data.data.pendingCandidateOrderCount,
        })

        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  // 接单并生成合同
  async requireCreatePositionContract({ commit }, data) {
    try {
      let res = await getCreatePositionContract(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        data.cb && data.cb(res.data.errorCode)
        if (res.data.errorCode == '2026' || res.data.errorCode == '2047') {
          return false
        }
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  // 判断是否为医脉职位
  async reqIsYIMAIJob({ commit }, data) {
    try {
      let res = await isYIMAIJob(data)
      if (res.data.code == 200) {
        data.cb && data.cb(res.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  // 获取当前佣金规则凭证
  async requirePositionContractOfficial({ commit }, data) {
    try {
      let res = await getPositionContractOofficial(data)
      if (res.data.code == 200) {
        data.cb ? data.cb(res.data.data.contract_url) : ''
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  /*
          文件上传
       */
  async requestUpload({ state, commit }, data) {
    try {
      const res = await getUpload(data)

      if (res.data.code == 200) {
        commit('setStateItem', { key: 'license', value: res.data.data })
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 实名认证
  async requestAuthentication({ state, commit }, data) {
    try {
      data.is_h5 = 1
      const res = await getAuthentication(data)
      if (res.data.code == 200) {
        data.suc && data.suc(res.data.data)
        return false
      } else if (res.data.code == '201' && res.data.errorCode == '329') {
        // 展示输入姓名弹窗
        data.suc && data.suc()
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 实名认证状态查询
  async requestAuthenticationStatus({ state, commit }, data) {
    try {
      const res = await getAuthenticationStatus(data)
      if (res.data.code == 200) {
        data.suc && data.suc(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 自动加入契约锁
  async requestAddUsreToQiyuesuo({ state, commit }, data) {
    try {
      const res = await getAddUsreToQiyuesuo(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  //隐私号
  async requirePrivacyNumber({ commit }, data) {
    try {
      let res = await getPrivacyNumber(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        commit('setStateItem', { key: 'privacyData', value: res.data.data })
        return false
      } else {
        data.cb && data.cb(res.data.errorCode)
        if (res.data.errorCode == '426') {
          return false
        }
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  //职位分享内容
  async requireJobShareParameter({ commit }, data) {
    try {
      let res = await getJobShareParameter(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'shareParameter', value: res.data.data })
        commit('setStateItem', {
          key: 'share_content',
          value: res.data.data.share_content,
        })

        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },

  async getCompanyDetail({ state, commit }, data) {
    try {
      let res = await getCompanyDetail(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'companyDetail',
          value: res.data.data,
        })
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getJobCommissionRule({ state, commit }, data) {
    try {
      let res = await getJobCommissionRule(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'jobCommissionRule',
          value: res.data.data,
        })
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  //获取发单顾问信息
  async getUserInfoByJobId({ state, commit }, data) {
    try {
      let res = await getUserInfoByJobIds(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'senderInfo',
          value: res.data.data,
        })
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },

  async addJobViewRecord({ _ }, data) {
    try {
      await addJobViewRecord(data)
    } catch (e) {
      console.log(e)
    }
  },
  async setBehavioralData({ _ }, data) {
    try {
      await setBehavioralData(data)
    } catch (e) {
      console.log(e)
    }
  },
  async getObsUrl({ state, commit }, data) {
    try {
      const res = await getObsUrl({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        data && data.cb && data.cb(res.data.data)
      } else {
        Toast(
          (res && res.data && (res.data.message || res.data.msg)) || '',
          'erro'
        )
        data && data.cb && data.cb()
      }
    } catch (e) {
      data && data.cb && data.cb()
    }
  },
  //
  async jobPackageStatistics({ commit }, data) {
    try {
      let res = await jobPackageStatistics(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (error) {
      return false
    }
  },
  setShowLogin({ commit }, data) {
    commit('setStateItem', { key: 'showLogin', value: data })
  },
  setLicense({ commit }, data) {
    commit('setStateItem', { key: 'license', value: data })
  },
}

export default {
  state,
  actions,
  mutations,
  namespaced: true,
}
